import React from 'react';
import {
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	Col,
	Row
} from 'reactstrap';
import TimeframePicker from 'components/Charts/TimeframePicker';
import { chartService } from '../services';
import moment from 'moment';
import VoiceAnalyzeTable from "components/Tables/VoiceAnalyzeTable";

class AiCallInsights extends React.Component {
	constructor(props) {
		super(props);
		var ds = new Date();
		ds.setHours(0);
		ds.setMinutes(0);
		ds.setSeconds(0);
		var de = new Date();
		de.setHours(23);
		de.setMinutes(59);
		de.setSeconds(59);
		this.state = {
			DateStart: ds,
			DateEnd: de,
			Data: [],
			Page: 1,
			TotalCount: 0,
			PageSize: 100,
			Loading: false
		};
	}

	onUpdateChart = (obj) => {
		this.setState(
			{DateStart: obj.start, DateEnd: obj.end, Page: 1},
			this.refreshData
		);
	}

	onPageChange = (newPage) => {
		this.setState({Page: newPage}, this.refreshData);
	}

	refreshData = () => {
		const {DateStart, DateEnd, Page} = this.state;
		this.setState({Loading: true});

		chartService.getVoiceAnalyzeScoring(
			moment(DateStart).format('YYYY-MM-DD 00:00:00+10'),
			moment(DateEnd).format('YYYY-MM-DD 23:59:59+10'),
			Page
		).then(resp => {
			this.setState({
				Data: resp.data || [],
				TotalCount: resp.total_count || 0,
				PageSize: resp.page_size || 100,
				Page: resp.page || 1,
				Loading: false
			});
		}).catch(() => {
			this.setState({Loading: false});
		});
	}

	render() {
		const {Data, Page, TotalCount, PageSize, Loading} = this.state;

		return (
			<>
				<div className="content">
					<Row>
						<Col xs={12}>
							<Card>
								<CardHeader>
									<h4>Reporting Timeframe</h4>
								</CardHeader>
								<CardBody>
									<TimeframePicker
										disableInterval={true}
										intervals={["hours", "daily", "weekly", "monthly"]}
										onUpdateChart={this.onUpdateChart}
									/>
								</CardBody>
							</Card>
						</Col>
					</Row>
					<Row>
						<Col xs="12">
							<Card className="card-table">
								<CardHeader>
									<Row>
										<Col className="text-left" sm="6">
											<h5 className="card-category">&nbsp;</h5>
											<CardTitle tag="h2">AI Call Insights</CardTitle>
										</Col>
										<Col className="text-right" sm="6">
											<span className="text-muted">
												{TotalCount} total records
											</span>
										</Col>
									</Row>
								</CardHeader>
								<CardBody>
									{Loading ? (
										<div className="text-center">Loading...</div>
									) : (
										<VoiceAnalyzeTable
											data={Data}
											page={Page}
											totalCount={TotalCount}
											pageSize={PageSize}
											onPageChange={this.onPageChange}
										/>
									)}
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</>
		);
	}
}

export default AiCallInsights;
